var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDensity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.466675,
    y: 14.0667,
    width: 2,
    height: 17.0667,
    rx: 1,
    transform: "rotate(-90 0.466675 14.0667)",
    fill: "#8E8E8E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.466675,
    y: 8.06666,
    width: 2,
    height: 17.0667,
    rx: 1,
    transform: "rotate(-90 0.466675 8.06666)",
    fill: "#8E8E8E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.466675,
    y: 2.06666,
    width: 2,
    height: 17.0667,
    rx: 1,
    transform: "rotate(-90 0.466675 2.06666)",
    fill: "#8E8E8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDensity);
export default __webpack_public_path__ + "static/media/density.1dbee6a27c1d5e5100dc9b02dc17f534.svg";
export { ForwardRef as ReactComponent };